// extracted by mini-css-extract-plugin
module.exports = {"root":"VerticalContainer_root__2KnYT"};